<div id="main-content" class="wrapper has-padding margin-height zoom-margin"
  (focusout)="onFocusOutMainContent()">
  <form [formGroup]="ackData">

    <div class="bottom-space padding-top-three">
      <h1 class="bofa--heading is-4">Non-US FINRA Acknowledgment </h1>
      <div>
        <button #pdfButton type="button" class="bofa--button secondary outlined"
          title="Required to view Acknowledgment of Consent" (click)="downloadAcknowledgmentPDF()"><abbr
            title="required" for="termsCheckLabel">* </abbr>Download and view Acknowledgement of Consent</button>

        <mat-checkbox [checked]="termsCheck" [disabled]="true" id="termsCheckLabel"></mat-checkbox>
      </div>

      <div *ngIf="!termsCheck && hasBeenSubmitted" class="padding-top">
        <mat-error>Please download and view Acknowledgement of Consent to continue</mat-error>
      </div>

      <div class="padding-top">
        <mat-checkbox aria-required="true" class="minor-check-padding" required formControlName="isFinraTermsConditionsAccepted">
          <mat-label class="whitespace-normal"><abbr title="required">* </abbr>Yes, I certify that I have read and understand the information presented </mat-label>
        </mat-checkbox>
        <mat-error class="whitespace-normal" *ngIf="isFinraTermsConditionsAccepted.touched && isFinraTermsConditionsAccepted.invalid"> Please check the box to agree to the above language </mat-error>
        <mat-form-field class="margin-left-space max-zoom radio-padding width-350-margins">
          <mat-label>Date Signed</mat-label>
          <input value="{{ termDate }}" matInput disabled>
        </mat-form-field>
      </div>
    </div>
                    
    <p class="bofa--heading is-8">By signing below you acknowledge that you have fully reviewed and completed the information above</p>
                    
      <div class="width-750-margins" *ngIf="afDisclosureInfo">
        <app-wet-signature [signatureImg]="signatureImg" (sigURL)="getUrl($event)" (sigCheck)="sigCheck($event)"> </app-wet-signature>
        <mat-error *ngIf="output.hasError('invalid') || sigCheckValue"> Please enter electronic signature </mat-error>
      </div>
                    
      <mat-checkbox aria-required="true" required formControlName="isFinraLegalRequirementsMet" class="minor-check-padding">
        <mat-label class="whitespace-normal"><abbr title="required">* </abbr>Yes, I agree that I have fully reviewed and
          completed the information above
        </mat-label>
      </mat-checkbox>
      <mat-error class="whitespace-normal" *ngIf="isFinraLegalRequirementsMet.touched && isFinraLegalRequirementsMet.invalid"> Please check the box to agree to the above language </mat-error>       
      <div>
        <mat-form-field class="max-zoom width-350-margins" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Please enter your full name</mat-label>
          <input matInput placeholder="Full name" formControlName="finraApplicantSignedName" required maxlength="250">
          <mat-error>Please enter a valid full name</mat-error>
        </mat-form-field>
      </div>
                    
      <div>
        <mat-form-field class="max-zoom width-350">
          <mat-label>Date Signed</mat-label>
            <input value="{{ date }}" matInput disabled>
         </mat-form-field>
      </div>

  </form>
</div>
  <ng-template #loading>
      Loading Acknowledgement Information...
  </ng-template>